import { useNavigate } from 'react-router-dom'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import users from 'modules/core/store/collections/users'

import AddWorkScheduleModal from 'modules/work_schedules/components/AddWorkScheduleModal'

const AddWorkScheduleModalPage = () => {
  const { navigation } = useNavigation()

  const navigate = useNavigate()

  const onClose = () => {
    navigate(navigation.settings.workSchedule.fullPath())
  }

  const onSuccess = (id: number) => {
    navigate(navigation.settings.workSchedule.id.fullPath({ id }))
  }

  return (
    <AuthorizeUser
      authorizeFn={() => users.current.policy.can('workSchedule.manageCompanySchedules')}
    >
      <AddWorkScheduleModal onClose={onClose} onSuccess={onSuccess} />
    </AuthorizeUser>
  )
}

export default AddWorkScheduleModalPage
